import { PlayerEnvironment } from './player_environment';

export default class PlayerDvr {
  constructor({ tech, data } = {}) {
    this._tech = tech;
    this._data = data;
  }

  tech() {
    return this._tech;
  }

  data() {
    return this._data;
  }

  static shouldInit({ data }) {
    return data.dvrEnabled() && PlayerEnvironment.browserName() !== 'Firefox Mobile';
  }

  init() {
    this.importPlugin();
    this.onPlayerStart();
  }

  importPlugin() {
    require('videojs-dvr');
  }

  onPlayerStart() {
    this.tech().on('vp-start', () => {
      this.tech().plugin().instance().dvr();
    });
  }
}
